import { Box, useColorModeValue } from "@chakra-ui/react";
import { LatLng } from "leaflet";
import { MapContainer, MapContainerProps } from "react-leaflet";

import { PopupNotification } from "components/Organismos/Map/PopupNotification";
import PopupNotificationProvider from "components/Organismos/Map/PopupNotification/PopupNotificationProvider";

import Spritesheet from "_assets/imgs/mapa/drawControl/spritesheet.png";
import SpritesheetDark from "_assets/imgs/mapa/drawControl/spritesheetDark.png";
import Rule from "_assets/imgs/mapa/measureControl/rule.png";
import RuleDark from "_assets/imgs/mapa/measureControl/ruleDark.png";

import "leaflet/dist/leaflet.css";
import "./styles.css";

export type MapProps = {
  children: React.ReactNode;
  center: LatLng;
  zoom: number;
} & MapContainerProps;

export const Map = ({ children, center, zoom, ...props }: MapProps) => {
  const iconDraw = useColorModeValue(Spritesheet, SpritesheetDark);
  const iconMeasure = useColorModeValue(Rule, RuleDark);
  const bgColor = useColorModeValue("white", "gray.900");
  const color = useColorModeValue("gray.600", "gray.300");
  const colorHover = useColorModeValue("gray.800", "gray.100");
  const borderColor = useColorModeValue("white", "gray.700");

  return (
    <Box
      h="full"
      w="full"
      sx={{
        ".leaflet-bar a, .leaflet-bar, .header-control, .leaflet-bar:not(.leaflet-draw-toolbar):not(.leaflet-popup-notice) a:hover, .leaflet-control-attribution, .leaflet-control-scale, .leaflet-control-scale-line, .leaflet-measure-resultpopup .leaflet-popup-content-wrapper":
          {
            bgColor: bgColor,
            color: color
          },
        ".leaflet-popup-notice": {
          bgColor: bgColor
        },
        ".leaflet-bar a:hover, .leaflet-bar button:hover": {
          color: colorHover
        },
        ".leaflet-bar a, .leaflet-bar a:hover": {
          borderBottomColor: borderColor
        },
        ".leaflet-control-scale-line": {
          borderColor: color
        },
        ".leaflet-draw-toolbar a": {
          backgroundImage: `url(${iconDraw}) !important`
        },
        ".leaflet-control-measure-toggle": {
          backgroundImage: `url(${iconMeasure}) !important`
        }
      }}
    >
      <PopupNotificationProvider>
        <MapContainer
          style={{ height: "100%", width: "100%" }}
          center={center}
          zoom={zoom}
          zoomControl={false}
          preferCanvas={true}
          attributionControl={false}
          {...props}
        >
          {children}
        </MapContainer>
        <PopupNotification />
      </PopupNotificationProvider>
    </Box>
  );
};
